export const environment = {
  production: false,
  api_url: "https://api.mediascopie.fr",
  curseur_url: "https://curseur.mediascopie.fr",
  client_id: "mediascopie_client_id",
  client_secret: "medi@scopie_client_secret",
};
